import styled from 'styled-components';

var VisuallyHiddenText = styled.span.withConfig({
  displayName: "VisuallyHiddenText",
  componentId: "sc-xkwgdn-0"
})(["position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden;"]);

export { VisuallyHiddenText };
